import { Link } from "react-router-dom";

function FeatureProduct({ productKey, image, title, price }) {
  console.log("FeatureProduct: Key :" + productKey);
  return (
    <div className="col">
      <div className="card shadow-sm">
        <img
          className="card-img-top bg-dark cover"
          height="240"
          alt=""
          src={image}
        />
        <div className="card-body">
          <h5 className="card-title text-center">{title}</h5>
          <p className="card-text text-center text-muted">{price}</p>
          <div className="d-grid gap-2">
            <Link
              to={{
                pathname: `/products/${productKey}`,
                state: {
                  id: productKey,
                  name: title,
                  price: price,
                  image: image,
                  quantity: 1,
                },
              }}
              className="btn btn-outline-dark"
            >
              Detail
            </Link>

          </div>
        </div>
      </div>
    </div>
  );
}

export default FeatureProduct;